import { AssetsFile, BaseLoaderUtil, LetterWritingPaths } from '../../types/asset/asset.types.ts';
import { KeyedWritingPath, WritingPathStyle } from '../../types/asset/writing-path.types.ts';

import { getSentryUtil } from '../monitoring/sentry.util.ts';

export class WritingPathsUtil implements BaseLoaderUtil {
  private static _instance: WritingPathsUtil;
  private writingPaths: LetterWritingPaths | null = null;

  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  public static get instance(): WritingPathsUtil {
    if (!WritingPathsUtil._instance) {
      WritingPathsUtil._instance = new WritingPathsUtil();
    }
    return WritingPathsUtil._instance;
  }

  load(assets: AssetsFile): void {
    this.writingPaths = assets['writing-paths'];
    if (!this.writingPaths) {
      console.error('No writing paths found');
      return;
    }
    const count = Object.values(this.writingPaths).reduce((acc, value) => acc + Object.keys(value).length, 0);
    console.log(`Loaded ${count} writing paths`);
  }

  getWritingPath(letter: string): KeyedWritingPath | null {
    const writingPath = this.writingPaths?.[WritingPathStyle.Default]?.[letter];
    if (!writingPath) {
      getSentryUtil().trackError(new Error('No writing path found'), {
        availableLetters: Object.keys(this.writingPaths?.[WritingPathStyle.Default] ?? {}).join(', '),
        letter,
      });
      return null;
    }
    return {
      ...writingPath,
      letter,
    };
  }
}

export const getWritingPathsUtil = (): WritingPathsUtil => WritingPathsUtil.instance;
